import { Button, IconButton } from '@monorepo/nova-ui';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    position: 'relative',
  },
});

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  ...theme.typography.h3,
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  paddingRight: theme.spacing(24),
  [theme.breakpoints.down('sm')]: {
    paddingRight: theme.spacing(16),
  },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(5),
  right: theme.spacing(5),
  [theme.breakpoints.down('sm')]: {
    top: theme.spacing(4),
    right: theme.spacing(4),
  },

  '& svg': {
    width: theme.spacing(5),
    height: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  maxHeight: theme.spacing(120),
  [theme.breakpoints.down('sm')]: {
    maxHeight: theme.spacing(100),
  },
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  '& form': {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    gap: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(4),
    },
  },
}));

export const StyledStateContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: theme.spacing(50),
  gap: theme.spacing(2),
}));

export const StyledErrorTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  color: theme.palette.error.main,
}));

export const StyledErrorMessage = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));

export const StyledTermsContent = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.text.fourth} transparent`,
  '&::-webkit-scrollbar': {
    width: theme.spacing(2),
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: theme.customShape.borderRadiusSmall,
    backgroundColor: theme.palette.text.fourth,
  },
}));

export const StyledTermsList = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

export const StyledTermsListItem = styled(Box)(({ theme }) => ({
  display: 'list-item',
  listStyleType: 'disc',
  paddingLeft: theme.spacing(2),
  whiteSpace: 'pre-line',
  '&::marker': {
    color: theme.palette.text.primary,
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  backgroundColor: theme.palette.background.contrast,
  borderRadius: theme.customShape.borderRadius3XL,
  padding: theme.spacing(2, 4),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  margin: 0,
  '& .MuiFormControlLabel-label': {
    ...theme.typography.caption,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export const StyledButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const StyledBaseButton = styled(Button)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),

  [theme.breakpoints.down('sm')]: {
    flex: 'none',
    width: '100%',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const StyledApplyButton = styled(StyledBaseButton)({
  flex: '3 1 0%',
});

export const StyledCancelButton = styled(StyledBaseButton)({
  flex: '1 1 0%',
});
